import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { AppAccessGate } from '@/components/auth/AppAccessGate';
import { MfaSetupGate } from '@/components/auth/MfaSetupGate';
import { ROUTES } from '@/constants';

export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  if (status === 'idle' || status === 'loading') {
    return <div className="fixed inset-0 flex items-center justify-center">Cargando…</div>;
  }
  if (status === 'unauthenticated') return <Navigate to={ROUTES.LOGIN} replace />;
  // authenticated → aplicar portón de app + gate de MFA + rutas hijas
  return (
    <AppAccessGate>
      <MfaSetupGate><Outlet /></MfaSetupGate>
    </AppAccessGate>
  );
}
